"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styleContents = __importStar(require("../style"));
const BaseStyle_1 = require("../style/BaseStyle");
const utils_1 = require("../../internal/utils");
class BaseHeader {
    constructor(_options = {}) {
        this.onDrawCell = this.onDrawCell.bind(this); //スコープを固定させる
    }
    get StyleClass() {
        return BaseStyle_1.BaseStyle;
    }
    onDrawCell(cellValue, info, context, grid) {
        const { style, drawCellBase } = info;
        const helper = grid.getGridCanvasHelper();
        drawCellBase();
        //文字描画
        this.drawInternal(this.convertInternal(cellValue), context, styleContents.of(style, this.StyleClass), helper, grid, info);
    }
    convertInternal(value) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return utils_1.isDef(value) ? `${value}` : "";
    }
    bindGridEvent(_grid, _cellId) {
        return [];
    }
}
exports.BaseHeader = BaseHeader;
